import copy from "copy-to-clipboard";

export function copyToClipboard(value: string) {
  return copy(value);
}
